/* eslint-disable sort-keys */
export function cleanRemuneration(obj) {
  if (!obj) return null;

  const currencyLookup = {
    EURO: "€",
    GBP: "£",
    USD: "$",
  };

  const intervalLookup = {
    HOURLY: "an hour",
    DAILY: "a day",
    WEEKLY: "a week",
    MONTHLY: "a month",
    YEARLY: "a year",
  };

  const { description = "", interval = "", currency, ranges = [] } = obj;

  return {
    description,
    currency: currency || "GBP",
    unitText: interval.replace("LY", ""),
    unitTextDisplay: intervalLookup[interval] || "",
    sign: currencyLookup[(currency || "GBP").toUpperCase()],
    fixed: (ranges.find((r) => r.type === "FIXED") || {}).value,
    min: (ranges.find((r) => r.type === "MIN") || {}).value,
    max: (ranges.find((r) => r.type === "MAX") || {}).value,
  };
}

// https://gist.github.com/kottenator/9d936eb3e4e3c3e02598#gistcomment-2209229
export function calculatePagination(currentPage, pageCount) {
  const range = [1];
  const rangeWithDots = [];
  const delta = 2;
  let l;

  if (pageCount <= 1) return range;

  for (let i = currentPage - delta; i <= currentPage + delta; i += 1) {
    if (i < pageCount && i > 1) range.push(i);
  }
  range.push(pageCount);

  range.forEach((idx) => {
    if (l) {
      if (idx - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (idx - l !== 1) {
        rangeWithDots.push("...");
      }
    }
    rangeWithDots.push(idx);
    l = idx;
  });

  return rangeWithDots;
}

export function isExpired(dateStr, testDate) {
  const today = testDate || new Date(new Date().setHours(0, 0, 0, 0));
  const date = new Date(dateStr);
  return today > date;
}
